import React, { useEffect, useState } from 'react';
import { TaskExecutionType } from '../../../api/models/tasks';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { TpAssetInfo } from '../../../data/assets/interfaces';
import { addNewAsset, selectQueriedAssets } from '../../../data/assets/queriedAssetsSlice';
import { selectTemplatesAndCombinedOntology } from '../../../data/templateSlice';
import { getAssetInfo, getAssetTypeIcon, getAssetTypeName, useOpenAsset } from '../../../data/assets/helpers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from '../TaskExecution.module.scss';
import { FancyButton } from '../../../components/primitives/FancyButton';
import { useApiContext } from '../../../api';

interface TaskInputAssetsProps {
  selectedTask: TaskExecutionType;
  inputAssetsKey: string;
}

const TaskInputAssets = (props: TaskInputAssetsProps) => {
  const { selectedTask, inputAssetsKey } = props;
  const { ontology } = useAppSelector(selectTemplatesAndCombinedOntology);
  const queriedAssetsData = useAppSelector(selectQueriedAssets);
  const [inputAssets, setInputAssets] = useState<TpAssetInfo[]>([]);
  const [showAllInputAssets, setShowAllInputAssets] = useState(false);
  const api = useApiContext();
  const dispatch = useAppDispatch();

  const openAsset = useOpenAsset();

  useEffect(() => {
    api.asset.listAssetRelations(selectedTask.parentAssetId).then((relations) => {
      for (const rel of relations) {
        if (rel.isReverse) {
          dispatch(addNewAsset({ asset: rel.toAsset }));
        } else {
          const asset: TpAssetInfo = { ...rel.toAsset, relations: [] };
          dispatch(addNewAsset({ asset }));
        }
      }
    });
  }, [selectedTask]);

  useEffect(() => {
    const inputAssetIds: string[] | null = selectedTask.executingParameters[inputAssetsKey];
    if (Array.isArray(inputAssetIds)) {
      setInputAssets(
        inputAssetIds
          .map((assetId: string) => {
            return getAssetInfo(assetId, queriedAssetsData);
          })
          .filter((asset) => asset !== null) as TpAssetInfo[],
      );
    } else {
      setInputAssets([]);
    }
  }, [selectedTask, queriedAssetsData]);

  function displaysetInputAssetTag(inputAsset: TpAssetInfo) {
    return (
      <>
        <div
          key={inputAsset.id}
          style={{ position: 'relative', display: 'inline-block', margin: '7px' }}
          className={styles.inputAssetTag}
          onClick={() => {
            openAsset(inputAsset.id);
          }}
        >
          <div className={styles.inputAssetIcon}>
            <FontAwesomeIcon icon={['fas', getAssetTypeIcon(ontology.assetTypes[inputAsset.type])]} />
          </div>
          <div className={styles.inputAssetTypeName}>{getAssetTypeName(ontology.assetTypes[inputAsset.type])}</div>
          <div className={styles.inputAssetName}>{inputAsset.displayName}</div>
        </div>
      </>
    );
  }

  return (
    <>
      {inputAssets.length > 0 && (
        <div className={styles.inputAssetTagContainer}>
          {inputAssets.slice(0, showAllInputAssets ? inputAssets.length : 6).map((asset, index) => (
            <div key={index}>{displaysetInputAssetTag(asset)}</div>
          ))}
          {inputAssets.length > 6 && (
            <div className={styles.buttonContainer}>
              <FancyButton
                iconName={showAllInputAssets ? 'fa-caret-up' : 'fa-caret-down'}
                onClick={() => setShowAllInputAssets(!showAllInputAssets)}
              >
                {showAllInputAssets ? 'Collapse all inputs' : 'Show all inputs'}
              </FancyButton>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default TaskInputAssets;
